
// hey-listen.ai – Add Abo to Cart Helper
// Fügt ein Abo-Produkt (mit Selling Plan) direkt in den Warenkorb ein und leitet zum Warenkorb weiter
window.addAboToCart = function(variantId, sellingPlanId) {
  var btn = event && event.target ? event.target : null;
  if (btn) {
    btn.disabled = true;
    btn.textContent = 'Wird hinzugefügt...';
  }
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({
      items: [{
        id: variantId,
        quantity: 1,
        selling_plan: sellingPlanId
      }]
    })
  })
  .then(function(response) {
    if (response.ok) {
      window.location.href = '/cart';
    } else {
      response.json().then(function(data) {
        alert(data.description || 'Fehler beim Hinzufügen zum Warenkorb. Bitte versuche es erneut.');
        if (btn) {
          btn.disabled = false;
          btn.textContent = 'Zum Warenkorb hinzufügen';
        }
      });
    }
  })
  .catch(function(error) {
    console.error('Cart error:', error);
    alert('Fehler beim Hinzufügen zum Warenkorb. Bitte versuche es erneut.');
    if (btn) {
      btn.disabled = false;
      btn.textContent = 'Zum Warenkorb hinzufügen';
    }
  });
};

// Einmalkauf direkt in den Warenkorb legen und zum Warenkorb weiterleiten
window.addOneTimeToCart = function(variantId) {
  var btn = event && event.target ? event.target : null;
  if (btn) {
    btn.disabled = true;
    btn.textContent = 'Wird hinzugefügt...';
  }
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({
      items: [{ id: variantId, quantity: 1 }]
    })
  })
  .then(function(response) {
    if (response.ok) {
      window.location.href = '/cart';
    } else {
      response.json().then(function(data) {
        alert(data.description || 'Fehler beim Hinzufügen zum Warenkorb.');
        if (btn) { btn.disabled = false; btn.textContent = 'In den Warenkorb'; }
      });
    }
  })
  .catch(function(error) {
    alert('Fehler beim Hinzufügen zum Warenkorb.');
    if (btn) { btn.disabled = false; btn.textContent = 'In den Warenkorb'; }
  });
};
